import { ChainId, ERC20Token } from '@nominex/nomiswap-sdk'
import { tokens as ethereumTokens } from './1'
import { tokens as optimismTokens } from './10'
import { tokens as bscTokens } from './56'
import { tokens as gnosisTokens } from './100'
import { tokens as polygonTokens } from './137'
import { tokens as arbitrumTokens } from './42161'
import { tokens as avalancheTokens } from './43114'
import { ERC20TokensMap } from './types'

export const tokens: Record<ChainId, ERC20TokensMap> = {
  [ChainId.BSC]: bscTokens,
  [ChainId.ETHEREUM]: ethereumTokens,
  [ChainId.MATIC]: polygonTokens,
  [ChainId.OPTIMISM]: optimismTokens,
  [ChainId.GNOSIS]: gnosisTokens,
  [ChainId.ARBITRUM]: arbitrumTokens,
  [ChainId.AVALANCHE]: avalancheTokens,
}

export const BUSD: Record<ChainId, ERC20Token> = {
  [ChainId.BSC]: bscTokens.busd,
  [ChainId.ETHEREUM]: ethereumTokens.busd,
  [ChainId.MATIC]: polygonTokens.busd,
  [ChainId.OPTIMISM]: optimismTokens.busd,
  [ChainId.GNOSIS]: gnosisTokens.busd,
  [ChainId.ARBITRUM]: arbitrumTokens.busd,
  [ChainId.AVALANCHE]: avalancheTokens.busd,
}

export const DAI: Record<
  Exclude<ChainId, ChainId.OPTIMISM | ChainId.GNOSIS | ChainId.ARBITRUM | ChainId.AVALANCHE>,
  ERC20Token
> = {
  [ChainId.BSC]: bscTokens.dai,
  [ChainId.ETHEREUM]: ethereumTokens.dai,
  [ChainId.MATIC]: polygonTokens.dai,
}

export const NMX: Record<ChainId, ERC20Token> = {
  [ChainId.BSC]: bscTokens.nmx,
  [ChainId.ETHEREUM]: ethereumTokens.nmx,
  [ChainId.MATIC]: polygonTokens.nmx,
  [ChainId.OPTIMISM]: optimismTokens.nmx,
  [ChainId.GNOSIS]: gnosisTokens.nmx,
  [ChainId.ARBITRUM]: arbitrumTokens.nmx,
  [ChainId.AVALANCHE]: avalancheTokens.nmx,
}

export const USDC: Record<ChainId, ERC20Token> = {
  [ChainId.BSC]: bscTokens.usdc,
  [ChainId.ETHEREUM]: ethereumTokens.usdc,
  [ChainId.MATIC]: polygonTokens.usdc,
  [ChainId.OPTIMISM]: optimismTokens.usdc,
  [ChainId.GNOSIS]: gnosisTokens.usdc,
  [ChainId.ARBITRUM]: arbitrumTokens.usdc,
  [ChainId.AVALANCHE]: avalancheTokens.usdc,
}

export const USDT: Record<ChainId, ERC20Token> = {
  [ChainId.BSC]: bscTokens.usdt,
  [ChainId.ETHEREUM]: ethereumTokens.usdt,
  [ChainId.MATIC]: polygonTokens.usdt,
  [ChainId.OPTIMISM]: optimismTokens.usdt,
  [ChainId.GNOSIS]: gnosisTokens.usdt,
  [ChainId.ARBITRUM]: arbitrumTokens.usdt,
  [ChainId.AVALANCHE]: avalancheTokens.usdt,
}
